import React, {Component} from "react";
import * as R from "ramda";
import {EquipmentSummary, StatsSummary} from "./CharacterSummary";
import {CharacterRecipes} from "./CharacterRecipes";
import {CharacterEquipment} from "./CharacterEquipment";
import "./CharacterBuilder.less"
import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {equipItem} from "./ducks/character";
import {getRecipe} from "./Boilerplate/ItemSmall";

const ToggleExpand = props => <div className='expand-container' onClick={props.onClick}>
  <a className="arrow"/>
</div>;

ToggleExpand.propTypes = {
  onClick: PropTypes.func,
  expanded: PropTypes.bool
};

class LeftPanel extends Component {
  render() {
    return <div className="sidebar sidebar-left" style={{...this.props.style}}>
      {this.props.children}
    </div>;
  }
}

export class RightPanel extends Component {
  render() {
    return <div className="sidebar sidebar-right">
      {this.props.children}
    </div>;
  }
}

class BottomPanel extends Component {
  render() {
    return <div className={"sidebar sidebar-bottom" + (this.props.expanded ? " expanded" : '')}>
      <ToggleExpand onClick={this.props.onExpand} expanded={this.props.expanded}/>
      {this.props.children}
    </div>;
  }
}

const initialState = {
  equipped: {
    head: null,
    body: null,
    weapon: null,
    wing: null,
    ring: null,
  },
  expanded: false,
};

export class _CharacterBuilder extends Component {
  state = {...initialState};

  setBlankAcquisition = item => {
    if (!getRecipe(item)) return;
    const crafting = JSON.parse(localStorage.getItem('crafting'));
    const setValues = value => obj => typeof(obj) !== 'object' ? value : R.map(setValues(value), obj);
    if (crafting[item] === undefined)
      localStorage.setItem('crafting', JSON.stringify(R.set(
        R.lensPath([item]),
        R.map(setValues(false), getRecipe(item, true)),
        crafting
      )));
  };

  componentDidMount() {
    const equipped = JSON.parse(localStorage.getItem('equipped'));
    const crafting = JSON.parse(localStorage.getItem('crafting'));
    if (!crafting) localStorage.setItem('crafting', JSON.stringify({}));
    if (equipped && Object.values(equipped).filter(i => i).length) {
      this.setState({equipped});
      for (let [slot, item] of Object.entries(equipped)) {
        item && this.props.equipItem && this.props.equipItem(item, slot);
        this.setBlankAcquisition(item);
      }
    }
  };

  handleClearItems = () => {
    const {equipped} = initialState;
    localStorage.setItem('equipped', JSON.stringify(equipped));
    ["head", "body", "weapon", "wing", "ring"].forEach(slot => {
      this.props.equipItem && this.props.equipItem(null, slot);
    });
    this.setState({equipped});
  };

  handleSelectItem = slot => selection => {
    const {equipped} = this.state;
    this.setBlankAcquisition(selection);
    localStorage.setItem('equipped', JSON.stringify(R.set(R.lensPath([slot]), selection, equipped)));
    this.props.equipItem && this.props.equipItem(selection, slot);
    return this.setState({equipped: R.set(R.lensPath([slot]), selection, equipped)});
  };

  toggleExpansion = () => {
    const {expanded} = this.state;
    return this.setState({expanded: !expanded})
  };

  render() {
    const {equipped, expanded} = this.state;
    const slots = {
      head: ['Headwear'],
      body: ['Armor'],
      weapon: ['Weapon (Shared)', 'Weapon (Melee)', 'Weapon (Staff)', 'Weapon (Bow)', 'Weapon (Gun)', 'Weapon (Bag)'],
      wing: ['Wings'],
      ring: ['Accessory']
    };
    window.slots = slots;

    return <div style={{
      position: 'relative',
      margin: 'auto',
      width: 800, height: 600,
      background: "#111e",
    }}>
      <LeftPanel style={{opacity: expanded ? 0 : 1}}>
        <EquipmentSummary equipped={equipped} character={slots}
                          handleSelectItem={this.handleSelectItem}/>
      </LeftPanel>
      <RightPanel>
        <StatsSummary equipped={equipped}/>
      </RightPanel>
      <BottomPanel expanded={expanded} onExpand={() => this.toggleExpansion()}>
        <CharacterRecipes equipped={equipped}/>
      </BottomPanel>
      <CharacterEquipment style={{opacity: expanded ? 0 : 1}} equipped={equipped} character={slots} handleSelectItem={this.handleSelectItem} handleClearItems={this.handleClearItems}/>
    </div>;
  }
}

export const CharacterBuilder = connect(
  null,
  (dispatch, props) => ({
    equipItem: (name, slot) => dispatch(equipItem(name, slot)),
  }),
)(_CharacterBuilder);
